import React, { useEffect, useState } from 'react'
import CustomDataTable from '../../../components/CustomDataTable'
import { FollowConfigService } from '../../../services/FollowConfigService';
import { useCurrentAccount } from '../../../hooks/useCurrentAccount';
import AddFollowModal from './AddFollowModal';
import { AlertService } from '../../../services/Alert';
import { useTranslation } from 'react-i18next';
import useRequest from '../../../hooks/useRequest';

export default function FollowUpPartial() {
    const { t } = useTranslation();
    const {call, isRequesting} = useRequest();
    const columns = [
        {
            name: t('config.tracking.name'),
            sortable: true,
            selector: row => row.name

        },
        {
            name: t('config.tracking.trigger'),
            sortable: true,
            selector: row => row.trigger,
            cell: row => {
                return (
                    <div>
                        {
                            ((() => {
                                switch (row.trigger.toLowerCase()) {
                                    case 'none':
                                        return <p className='m-0'>{t('config.tracking.no-trigger')}</p>;
                                    case 'sleep':
                                        return <p className='m-0'>{t('config.tracking.sleep')}</p>;
                                    case 'redirect':
                                        return <p className='m-0'>{t('config.tracking.redirect')}</p>;
                                    case'close':
                                        return<p className='m-0'>{t('config.tracking.close')}</p>;
                                    default: <p className='m-0'>{row.trigger}</p>;
                                }
                            })())
                        }
                    </div>
                )
            },

        },
        {
            name: t('config.tracking.status'),
            sortable: true,
            formatToExport: row => row.status === 1 ? 'Activo' : 'Inactivo',
            selector: row => row.status,
            cell: (row) => {
                return (
                    row.status === 1 ?
                        (
                            <span className="badge bg-soft-info text-info">
                                <span className="legend-indicator bg-info"></span> {t('config.tracking.active')}
                            </span>
                        ) :
                        (
                            <span className="badge bg-soft-danger text-danger">
                                <span className="legend-indicator bg-danger"></span> {t('config.tracking.inactive')}
                            </span>
                        )
                )
            }

        },
        {
            name: t('config.tracking.actions'),
            sortable: false,
            center: true,
            cell: (row) => {
                return (
                    <div className="btn-group" role="group">
                        <button className="btn bg-soft-info-alternative text-white-dark btn-sm" onClick={() => setShowModal({ show: true, data: row })}>
                            {t('btn-edit')}
                        </button>
                        <div className="btn-group">
                            <button type="button" className="btn bg-soft-info-alternative text-white-dark btn-icon btn-sm dropdown-toggle dropdown-toggle-empty" data-bs-toggle="dropdown" aria-expanded="false"></button>
                            <div className="dropdown-menu dropdown-menu-end mt-1" >
                                <button className="dropdown-item" onClick={() => changeStatus(row.id, row.status)}>
                                    {
                                        row.status === 1 ? t('btn-disable') : t('btn-enable')
                                    }
                                </button>
                                <button className="dropdown-item" onClick={() => deleteTag(row)}>
                                {t('btn-delete')}
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }

        }
    ]

    const { account } = useCurrentAccount();
    const [rows, setRows] = useState([]);

    const [showModal, setShowModal] = useState({
        show: false,
        data: null
    })

    const handleShowModal = async (refresh: boolean) => {
        if (refresh) {
            await getAll()
        }
        setShowModal({ show: false, data: null })
    }

    const getAll = async () => {
         const {data} = await call(() => FollowConfigService.getTags(account.id));
        setRows(data);
    }

    const deleteTag = async (data) => {
        const isConfirmed = await AlertService.warning('Borrar Seguimiento', '¿Estás seguro de querer borrar este seguimiento? Esta acción no se puede deshacer', async () => {
            try {
                console.log(data.id);
                await FollowConfigService.deleteTag(account.id, data.id);
                await getAll();
            } catch (error) {
                console.error(error);
                AlertService.error('¡Error!', 'Ocurrió un error al borrar el formulario, intenta nuevamente')
            }
        });
        if (isConfirmed) {
            AlertService.success('¡Éxito!', 'Se borró el formulario correctamente');
        }
    }

    const changeStatus = async (id, status) => {
        const isConfirmed = await AlertService.warning('Aviso', `¿Estás seguro de cambiar el estatus del seguimiento? Esta acción se puede cambiar en cualquier momento`, async () => {
            try {
                const newStatus = status == 1 ? 0 : 1;
                const data = {
                    id: id,
                    status: newStatus
                }
                await FollowConfigService.changeStatus(account.id, data);
                await getAll();
            } catch (error) {
                console.log(error)
                AlertService.error('¡Error!', 'No se pudo cambiar el estatus del seguimiento, intenta más tarde.')
            }
        });
        if (isConfirmed) {
            AlertService.toastSuccess('Se cambio el estatus del seguimiento correctamente.')
        }
    }

    useEffect(() => {
        getAll();
    }, [])

    return (
        <>
            <div className='card'>
                <div className='card-header d-flex align-items-center'>
                    <div className="me-3">
                        <h2 className="card-title h4">{t('config.tracking.tracking-title')}</h2>
                        <p className="small mb-0">
                        {t('config.tracking.tracking-text')}
                        </p>
                    </div>

                    <div className="col-sm-auto">
                        <button className="btn btn-primary btn-sm" onClick={() => setShowModal({ show: true, data: null })}>
                            <i className="bi-plus-lg me-1"></i>
                           {t('config.tracking.add-btn')}
                        </button>
                    </div>
                </div>
                <div className='card-body'>
                    <CustomDataTable
                        columns={columns}
                        data={rows}
                        hideAccountsFilter
                        isLoading={isRequesting}
                        filter={(row, term) => {
                            if (!term) return true;
                            return (
                                `${row.status}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.name}`.match(new RegExp(`${term}`, 'i')) ||
                                `${row.trigger}`.match(new RegExp(`${term}`, 'i'))
                            )
                        }}
                    />
                </div>
            </div>
            <AddFollowModal
                show={showModal.show}
                onRequestClose={(refresh) => handleShowModal(refresh)}
                payload={showModal.data}
            />
        </>
    )
}
